export interface UpdateClaimFieldPayload {
  claimNumber: string;
  claimFields: {
    claimNumber: string;
    autoClaimDetails: [
      {
        year: string;
        make: string;
        model: string;
        vin: string;
      }
    ];
  };
}
